function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdPlanPerkMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {},
    fill: "#ff432e",
    "data-original": "#ff432e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.28 275.28 389.333 153.333 122.667 421.5l86.142 86.142A257.36 257.36 0 0 0 256 512c134.899 0 245.422-104.341 255.28-236.72z",
    style: {},
    fill: "#db0404",
    "data-original": "#db0404",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 75H122.667v346.5h266.666V153.333z",
    style: {},
    fill: "#ffffff",
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.333 153.333 311 75h-55.429v346.5h133.762z",
    style: {},
    fill: "#f2f6fc",
    "data-original": "#f2f6fc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 153.333h78.333L311 75z",
    style: {},
    fill: "#dce1eb",
    "data-original": "#dce1eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156 362 49-53h151V190.25H156z",
    style: {},
    fill: "#8783d1",
    "data-original": "#4a7aff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57 190.25H356V309H255.57z",
    style: {},
    fill: "#6d69b0",
    "data-original": "#2864f0",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.67 214.25h156.67v14.414H177.67z",
    style: {},
    fill: "#b7b4f1",
    "data-original": "#a3d4ff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57 214.25h78.76v14.414h-78.76z",
    style: {},
    fill: "#a19de7",
    "data-original": "#87c7ff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.67 241.04h156.67v14.414H177.67z",
    style: {},
    fill: "#b7b4f1",
    "data-original": "#a3d4ff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57 241.04h78.76v14.414h-78.76z",
    style: {},
    fill: "#a19de7",
    "data-original": "#87c7ff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.67 267.84h156.67v14.414H177.67z",
    style: {},
    fill: "#b7b4f1",
    "data-original": "#a3d4ff",
    className: "",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57 267.84h78.76v14.414h-78.76z",
    style: {},
    fill: "#a19de7",
    "data-original": "#87c7ff",
    className: "",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdPlanPerkMessageIcon);
export default __webpack_public_path__ + "static/media/ad-plan-perk-message-icon.d58172b8a650062fe6e99a581156ab04.svg";
export { ForwardRef as ReactComponent };